import useRouter from "@stadium/hooks/lib/use-custom-route";
import classNames from "classnames";

import { useModal } from "@stadium/hooks/lib/use-modal";
import { useStoreContext } from "@components/store/provider";
import { useWithAnalytics } from "@stadium/services/analytics/hooks/use-with-analytics";
import { useCreateSwagContext } from "@contexts/create-swag-context";

import Multimedia from "@sharedComponents/multimedia";
import ProductDetailsModal from "@components/store/product-details-modal";
import Button from "@stadium/ui/src/components/button/button";

import { getPreviewCatalogModalDetail } from "@helpers/catalog";

import { PRODUCT_DETAILS_MODAL } from "@constants/modal-types";
import { getProductRoute } from "@constants/routes";
import { HEADER_ANALYTICS_TARGET } from "@stadium/shared/src/constants/analytics/header";
import {
  ANALYTICS_TARGET_PRODUCT,
  ANALYTICS_EVENT_ACTION_PERFORMED,
} from "@stadium/services/analytics/constants/default";

import NoImage from "@assets/images/no-image.svg";

import defaultStyles from "./main.module.scss";

const SearchedProducts = ({ data, setSearchValue, styles = defaultStyles, handleClick }) => {
  const { id, name, brand, baseImage, slug, broken = false, brokenVariantId = "" } = data;
  const brandName = brand?.displayName;
  const {
    openModal: openProductDetailsModalCatalog,
    renderModal: renderProductDetailsModalCatalog,
  } = useModal(PRODUCT_DETAILS_MODAL, ProductDetailsModal);
  const { storeBasePath, isPreviewCatalogMode } = useStoreContext();
  const router = useRouter();
  const { isSwagCreationShopFlow } = useCreateSwagContext();
  const withAnalytics = useWithAnalytics();
  const redirectToProductDetail = (slug, broken = false, brokenVariantId = "") => {
    withAnalytics(undefined, {
      track: true,
      target: HEADER_ANALYTICS_TARGET.SEARCH,
      action: ANALYTICS_EVENT_ACTION_PERFORMED,
      eventProperties: {
        product_id: id,
        product_name: name,
        search_result_type: ANALYTICS_TARGET_PRODUCT,
      },
    })();
    handleClick?.();
    setSearchValue("");
    router.push(
      getProductRoute({
        productSlug: slug,
        storeBasePath,
        broken,
        brokenVariantId,
      }),
    );
  };

  const renderContent = () => (
    <>
      <div className={styles.imgBox}>
        <Multimedia
          type="image"
          src={baseImage || NoImage}
          height={40}
          width={40}
          isNextImage={false}
          aria-hidden="true"
        />
      </div>
      <div className={styles.itemDetail}>
        {brandName && <p className="">{brandName}</p>}
        <div className={styles.name}>{name}</div>
      </div>
    </>
  );

  return !isPreviewCatalogMode && !isSwagCreationShopFlow ? (
    <Button
      key={id}
      onClick={() => redirectToProductDetail(slug, broken, brokenVariantId)}
      onKeyDown={() => redirectToProductDetail(slug, broken, brokenVariantId)}
      customClass={styles.searchedItem}
    >
      {renderContent()}
    </Button>
  ) : (
    <>
      <Button
        key={id}
        onClick={(e) => {
          e.preventDefault();
          openProductDetailsModalCatalog(id);
        }}
        onKeyDown={openProductDetailsModalCatalog}
        customClass={styles.searchedItem}
      >
        {renderContent()}
      </Button>
      {renderProductDetailsModalCatalog({
        classes: {
          rootClass: styles.productDetailsCatalogPrimaryModal,
          dialogClass: classNames(
            styles.modalDialogCatalogProductDetails,
            styles.revampDesign,
            isSwagCreationShopFlow && styles.swagCreationShopDialog,
          ),
        },
        data: {
          ...getPreviewCatalogModalDetail(data),
          classes: {
            productImgClass: styles.catalogModeImgSection,
            productContentClass: styles.catalogModeContentClass,
          },
        },
      })}
    </>
  );
};

export default SearchedProducts;
